import { createEffect } from 'effector'
import {
  getCurrencyRate,
  getPaymentInfo,
  getTransactionStatus,
  getUpdateProgressInvoiceLink,
  postCreatePayment,
} from './api'
import { CreatePaymentDTO, GetUpdateProgressPaymentLinkResponse, TransactionStatusDTO } from './types'
import { getSubscriptionPrices } from '@/entities/user/api'
import { SubscriptionPriceType } from './types'

export const getCurrencyRatesFx = createEffect(async (token: string) => {
  const rates = getCurrencyRate(token)
  return rates
})

export const getPaymentInfoFx = createEffect(async (token: string) => {
  const response = getPaymentInfo(token)
  return response
})

export const getUpdateProgressInvoiceLinkFx = createEffect(
  async (token: string): Promise<GetUpdateProgressPaymentLinkResponse> => {
    const response = getUpdateProgressInvoiceLink(token)
    return response
  }
)

export const getSubscriptionPricesFx = createEffect(async (token: string): Promise<SubscriptionPriceType[]> => {
  const data = await getSubscriptionPrices(token)
  return data
})

export const getTransactionStatusFx = createEffect(async (params: TransactionStatusDTO) => {
  const response = getTransactionStatus(params)
  return response
})

export const createPaymentFx = createEffect(async (params: CreatePaymentDTO) => {
  const response = postCreatePayment(params)
  return response
})
